const modelConfig = {
  data() {
    return {
      // 定义控件类型开始
      TYPE_INPUTTEXT: 10, // 单行文本
      TYPE_PASSWORD: 20, // 密码
      TYPE_TEXTAREA: 30, // 多行文本
      TYPE_RADIO: 40, // 单选框
      TYPE_CHECKBOX: 50, // 多选框
      TYPE_SELECT: 60, // 下拉框
      TYPE_DATE: 70, // 日期
      TYPE_BOTH_DATE_TIME: 80, // 日期时间
      TYPE_TIME: 90, // 时间
      TYPE_EDITOR: 100, // 编辑器
      TYPE_CASCADER: 110, // 级联
      TYPE_FOREIGNKEY: 120, // 外键
      TYPE_SUBFORM: 130, // 子表单
      TYPE_FILE: 140, // 文件
      TYPE_PERSON: 150, // 人员选择
      TYPE_STRUCT: 160, // 部门选择
      TYPE_USER: 170, // 用户信息
      TYPE_DEALTIME: 180, // 获取系统时间
      TYPE_PARAMS: 190, // 字段扩展管理
      TYPE_MULTIRELATE: 200, // 多对多关联
      TYPE_PHOTO: 210, // 图片
      TYPE_SUBRELATE: 220, // 子表数据关联
      TYPE_OBTAIN_CONTENT: 230, // 接口获取内容
      // 定义控件类型结束
      // 定义单行文本类型开始
      TYPE_STRING: 10, // 字符串
      TYPE_NUMBER: 20, // 数字
      TYPE_ENGLISH: 30, // 英文
      TYPE_NUM_OR_ENG: 40, // 数字或英文
      TYPE_PHONE: 50, // 手机
      TYPE_EMAIL: 60, // 邮箱
      TYPE_IDCARD: 70, // 身份证号码
      TYPE_FLOATNUMBER: 80, // 浮点
      TYPE_FORMULA: 90, // 公式
      TYPE_BANK: 100, // 银行
      // 定义单行文本类型结束
      // 定义日期控件类型开始
      TYPE_DATESINGLE: 10, // 日期
      TYPE_DATERANGE: 20, // 日期范围
      TYPE_DATETIMERANGE: 30, // 日期时间范围
      // 定义日期控件类型结束
      // 定义富文本编辑器菜单类型开始
      MENU_UPLOAD: 10, // 图片上传
      MENU_WEB_IMAGE: 20, // 网络图片
      MENU_VIDEO: 30, // 插入视频
      MENU_MAP: 40, // 百度地图
      MENU_CODE: 50, // 插入代码
      MENU_FACELOOK: 60, // 表情
      // 定义富文本编辑器菜单类型结束
      // 定义文件上传控件类型开始
      UPLOAD_FILELIST: 10, // 文件列表
      UPLOAD_IMAGELIST: 20, // 图片列表
      UPLOAD_PHOTOWALL: 30, // 照片墙列表
      UPLOAD_DRAG: 40, // 拖拽上传列表
      // 定义文件上传控件类型结束
      // 定义密码哈希算法类型开始
      PASSWORD_MD5: 10, // md5
      PASSWORD_SHA256: 20, // sha-256
      // 定义密码哈希算法类型结束
      // 定义级联类型开始
      CASCADER_SELF: 10, // 自定义
      CASCADER_PROVINCE: 20, // 省市区级联
      // 定义级联类型结束
      // 定义级联显示结果类型开始
      CASCADER_SHOW_FULL: 10, // 全部显示
      CASCADER_SHOW_LAST: 20, // 只显示最后一级
      // 定义级联显示结果类型结束
      // 定义日期类型开始
      DATE_DAY: 10, // 日
      DATE_WEEK: 20, // 周
      DATE_MONTH: 30, // 月
      DATE_YEAR: 40, // 年
      // 定义日期类型结束
      // 定义日期最值限制类型开始
      DATE_LIMIT_NONE: 10, // 不限
      DATE_LIMIT_VAR: 20, // 变量限制
      DATE_LIMIT_FIXED: 30, // 固定值
      // 定义日期最值限制类型结束
      // 定义时间类型开始
      TIME_FIXED: 10, // 固定时间
      TIME_ANYTIME: 20, // 任意时间
      // 定义时间类型结束
      // 定义时间默认值类型开始
      TIME_DEFAULT_NULL: 10, // 空
      TIME_DEFAULT_VAR: 20, // 变量限制
      TIME_DEFAULT_FIXED: 30, // 固定值
      // 定义时间默认值类型结束
      // 定义是否固定时间间隔开始
      TIME_FIXED_STEP_TRUE: 1,
      TIME_FIXED_STEP_FALSE: 0,
      // 定义是否固定时间间隔结束
      // 定义操作时间单位开始
      DEALTIME_YEAR: 10,
      DEALTIME_MONTH: 20,
      DEALTIME_DAY: 30,
      DEALTIME_HOUR: 40,
      DEALTIME_MINUTE: 50,
      DEALTIME_SECOND: 60,
      // 定义操作时间单位结束
      // 定义外键类型开始
      KEY_SELECT: 10, // 下拉控件
      KEY_REMOTE: 20, // 模糊匹配
      // 定义外键类型结束
      // 定义图片处理方式开始
      IMG_NODEAL: 10, // 图片不处理
      IMG_FRONTDEAL: 20, // 图片前端处理
      IMG_BACKGROUNDDEAL: 30, // 图片后台处理
      // 定义图片处理方式结束
      // 定义流程表单开始
      UESR_CONSTANT: 10, // 常量
      USER_GROUP: 20, // 用户组
      USER_DEPARTMENT: 30 // 部门
      // 定义流程表单结束
    }
  }
}

export default modelConfig



// WEBPACK FOOTER //
// ./src/config/modelConfig.js